import Requester from "./Requester";

export function refresh(id: number) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/product-refresh/${id}`), [])
}

export default {
    refresh
}